/**
 * FIG-351: organisations-manager-v3 hands an anonymous visitor a draft token when it creates
 * their draft, and accepts later anonymous saves to that draft only with the token. It lives in
 * sessionStorage next to the rest of the onboarding state and is cleared with it.
 */

export const DRAFT_TOKEN_KEY = 'figabl_draft_token';

export function rememberDraftToken(organisationId: unknown, token: unknown): void {
  if (typeof sessionStorage === 'undefined') return;
  if (typeof organisationId !== 'string' || !organisationId) return;
  if (typeof token !== 'string' || !token) return;
  sessionStorage.setItem(DRAFT_TOKEN_KEY, JSON.stringify({ organisation_id: organisationId, token }));
}

export function draftTokenFor(organisationId: string | null | undefined): string | null {
  if (typeof sessionStorage === 'undefined' || !organisationId) return null;
  try {
    const stored = JSON.parse(sessionStorage.getItem(DRAFT_TOKEN_KEY) ?? 'null') as
      | { organisation_id?: unknown; token?: unknown }
      | null;
    if (stored?.organisation_id !== organisationId || typeof stored.token !== 'string') return null;
    return stored.token;
  } catch {
    return null;
  }
}

/** `{ draft_token }` for a request body when this tab holds the token for `organisationId`. */
export function draftTokenField(organisationId: string | null | undefined): { draft_token?: string } {
  const token = draftTokenFor(organisationId);
  return token ? { draft_token: token } : {};
}
